import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function Rotate90DegreesCcwIcon(props: IconProps) {
    return <Icon {...props} iconKey={"rotate_90_degrees_ccw"}/>
}
